import BrowserStorage from '@/scripts/helpers/browser-storage';

const _post = function _post(options, callback) {
  if (BrowserStorage.getItem('access_token')) {
    $.ajaxSetup({
      headers: {
        Authorization: 'Token token="' + BrowserStorage.getItem('access_token') + '"',
      },
    });
  }
  $.ajax({
    method: 'POST',
    url: options.url,
    data: options.params,
  }).done((res) => {
    callback(res);
  });
};

const postTrackerLog = function postTrackerLog(activity_type, other_params, callback) { // eslint-disable-line camelcase
  const options = {};

  options.url = 'https://tracker.viddsee.com/log';
  options.params = {};
  options.params.activity_type = activity_type; // eslint-disable-line camelcase
  if (BrowserStorage.getItem('user_id')) {
    options.params.user_id = BrowserStorage.getItem('user_id');
  }
  other_params.user_agent = navigator.userAgent;
  options.params.params = JSON.stringify(other_params);
  _post(options, callback);
};

const Tracker = {
  postTrackerLog,
};

export default Tracker;
